import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import {
  MetricTable,
  sortNumeric,
  selectFormat,
  Error,
} from "./../../Utils/Utils.js";

function metric(cell, row) {
  if (!cell || !cell.value) {
    return null;
  }

  if (cell.newValue) {
    return (
      <span className="metric-table">
        <span className="metric-table__primary">
          {selectFormat(cell.type, cell.value)}
        </span>{" "}
        <span className="metric-table__new">new</span>
      </span>
    );
  }

  return <MetricTable {...cell} />;
}

class SnapChatTopStories extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "80px", minWidth: "80px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "avg_time_viewed",
        text: "AVG Time Viewed",
        headerFormatter: (col, colIndex, { sortElement }) => (
          <div>
            AVG <br /> Time Viewed {sortElement}
          </div>
        ),
        style: { width: "80px", minWidth: "80px" },
        formatter: (cell, row) => metric({ ...cell, type: "time" }, row),
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: (a, b, order) =>
          order === "desc"
            ? a.value > b.value
              ? 1
              : -1
            : b.value > a.value
            ? 1
            : -1,
      },
    ];

    const defaultSorted = [
      {
        dataField: "views",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default SnapChatTopStories;
